module.exports = __webpack_public_path__ + "img/luck.81b07d8a.svg";